import React, { useState } from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';

import LocationPickerModal from '~/components/modal/LocationPickerModal';
import UnderlineButton from '~/components/buttons/UnderlineButton';

import { dynamicFontSize } from '~/utilities/helpers';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

const InnerWrapper = styled.div`
    display: flex;
    gap: 10px;

    @media (min-width: ${({ theme }) => theme.breakpoint.desktop}) {
        gap: 20px;
    }
`;

const Title = styled.h3`
    font-family: ${({ theme }) => theme.fonts.heading};
    font-weight: ${({ theme }) => theme.fontWeights.black};
    font-size: ${dynamicFontSize(1.6, 1.9, 2.4)};
`;

const Location = styled.p`
    display: inline-block;
    font-family: ${({ theme }) => theme.fonts.heading};
    font-weight: ${({ theme }) => theme.fontWeights.regular};
    font-size: ${dynamicFontSize(1.8, 2.2, 2.8)};
`;

const ConfirmWashLocation = ({ location, setLocation }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    return (
        <Wrapper>
            <Title>Confirm your wash location</Title>
            <InnerWrapper>
                <Location>
                    {location
                        ? `
                            ${location.address.line1}, ${location.address.city}, ${location.address.region} ${location.address.postalCode}`
                        : 'Select an Autobell Location'}
                </Location>
                <UnderlineButton
                    onClick={() => setIsModalOpen(true)}
                    icon="pencil"
                    iconSize={11}
                >
                    Edit
                </UnderlineButton>
                <LocationPickerModal
                    open={isModalOpen}
                    setOpen={setIsModalOpen}
                    {...{ setLocation }}
                />
            </InnerWrapper>
        </Wrapper>
    );
};

export default ConfirmWashLocation;

ConfirmWashLocation.propTypes = {
    location: PropTypes.object,
    setLocation: PropTypes.func.isRequired
};
